export enum SortingType {
  Popular = 'POPULAR',
  DateOlder = 'DATE_OLDER',
  DateNewer = 'DATE_NEWER',
  PriceLower = 'PRICE_LOWER',
  PriceHigher = 'PRICE_HIGHER',
}
